const rankings = [
  { rank: 1, title: '庆余年3', category: '国产古装', heat: '9.8', trend: 'up', desc: '权谋江湖再起风云，范闲归来引爆期待' },
  { rank: 2, title: '狂飙', category: '国产涉案', heat: '9.5', trend: 'stable', desc: '年度现象级扫黑剧，演技全员在线' },
  { rank: 3, title: '眼泪女王', category: '韩剧爱情', heat: '9.1', trend: 'up', desc: '金秀贤金智媛巅峰演绎，甜蜜暴击' },
  { rank: 4, title: '三体', category: '国产科幻', heat: '8.9', trend: 'up', desc: '刘慈欣巨著改编，国产科幻里程碑' },
  { rank: 5, title: '玫瑰的故事', category: '国产都市', heat: '8.5', trend: 'stable', desc: '刘亦菲主演，女性成长史诗级力作' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-12 md:py-16 bg-background-50 scroll-mt-20">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          热播榜单
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-8">实时热度排行，发现大家都在追的好剧</p>
        <div className="space-y-3">
          {rankings.map((item, i) => (
            <a
              key={i}
              href="#carousel"
              className="flex items-center gap-4 bg-background-100 rounded-lg border border-background-200/70 p-4 hover:border-primary-200 transition-all duration-200 cursor-pointer group"
            >
              <div className={`flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-lg font-heading text-lg font-bold ${
                item.rank === 1 ? 'bg-accent-500 text-background-50' :
                item.rank === 2 ? 'bg-secondary-400 text-background-50' :
                item.rank === 3 ? 'bg-primary-400 text-background-50' :
                'bg-background-200 text-foreground-700'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="font-heading text-base font-semibold text-foreground-950 whitespace-nowrap">{item.title}</h3>
                  <span className="text-xs text-foreground-500 bg-background-200 px-2 py-0.5 rounded whitespace-nowrap">{item.category}</span>
                </div>
                <p className="text-xs text-foreground-600 truncate">{item.desc}</p>
              </div>
              <div className="flex-shrink-0 text-right">
                <div className="text-lg font-bold text-accent-500 font-heading">{item.heat}</div>
                <div className="text-xs text-foreground-500">万热度</div>
              </div>
              <div className={`flex-shrink-0 w-6 h-6 flex items-center justify-center ${
                item.trend === 'up' ? 'text-primary-500' : 'text-foreground-400'
              }`}>
                {item.trend === 'up' ? <i className="ri-arrow-up-line"></i> : <i className="ri-arrow-right-line"></i>}
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}